module.exports = __webpack_public_path__ + "tables/media/E-commerce_outlined.d15cf9e3.svg";